import { createSlice } from "@reduxjs/toolkit";
import { smartPhrasesApi } from 'Services/SmartPhrasesService';

export const initialState = {
    loadingList: false,
    openUpsertDialog: false,
    openDeleteDialog: false,
    selectedPhrase: null,
    search: {
        searchTerm: '',
        documentType: ''
    },
    phraseList: []
};

const manageSmartPhrasesSlice = createSlice({
    name: "manage-smart-phrases",
    initialState,
    reducers: {
        handleChange: (state, action) => {
            state.search[action.payload.field] = action.payload.value;
        },
        handleOpenUpsertDialog: (state, action) => {
            state.selectedPhrase = action.payload || null;
            state.openUpsertDialog = true;
        },
        handleCloseUpsertDialog: (state) => {
            state.selectedPhrase = null;
            state.openUpsertDialog = false;
        },
        handleOpenDeleteDialog: (state, action) => {
            state.selectedPhrase = action.payload;
            state.openDeleteDialog = true;
        },
        handleCloseDeleteDialog: (state) => {
            state.selectedPhrase = null;
            state.openDeleteDialog = false;
        },
        handleClearSearch: (state) => {
            state.search.searchTerm = '';
            state.search.documentType = '';
        }
    },
    extraReducers: (builder) => {
        builder.addMatcher(
            smartPhrasesApi.endpoints.getAllPhrases.matchFulfilled, (state, action) => {
                state.loadingList = false;
                state.phraseList = action.payload;
            }
        )
        .addMatcher(
            smartPhrasesApi.endpoints.getAllPhrases.matchPending, (state) => {
                state.loadingList = true;
            }
        )
        .addMatcher(
            smartPhrasesApi.endpoints.getAllPhrases.matchRejected, (state) => {
                state.loadingList = false;
            }
        );
    }
});

export const {
    handleChange,
    handleOpenUpsertDialog,
    handleCloseUpsertDialog,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    handleClearSearch
} = manageSmartPhrasesSlice.actions;

export default manageSmartPhrasesSlice.reducer;
